if (!customElements.get('carousel-slider')) {
	customElements.define('carousel-slider', class CarouselSlider extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.carousel = this.querySelector('.grid-carousel');
			this.initialize();
		}

		initialize() {
    // 1. Prepare the container
    this.carousel.style.display = 'block';
    this.carousel.classList.add('is-loading');

    // 2. Initialize Flickity with Fade and Loop settings
    this.flickity = new Flickity(this.carousel, {
        cellAlign: 'left',
        groupCells: false, 
        contain: true,
        resize: true,
        draggable: true,
        prevNextButtons: false,
        fade: true, // Requires flickity-fade.js
        cellSelector: '.slideshow-slide',
        initialIndex: 0,
        pageDots: false,
        wrapAround: true,
        accessibility: false,
        watchCSS: false,
        autoPlay: 5000,
        on: {
            ready: () => {
                this.carousel.classList.remove('is-loading');
                this.carousel.classList.add('is-ready');
                // Force a resize to ensure the fade positioning is pixel-perfect
                this.flickity.resize();
            }
        }
    });

    // 3. Keep your event publishing logic
    this.flickity.on('change', (index) => {
        if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.sliderSlideChange, {
                id: this.getAttribute('id'),
                index,
            });
        }
    });
}
	});
}

if (!customElements.get('carousel-navigation')) {
	customElements.define('carousel-navigation', class CarouselNavigation extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.init();
		}

		init(retry = 1, maxRetry = 3) {
			if (retry === maxRetry) {
				return;
			}

			const id = this.getAttribute('for');
			this.carouselComponent = document.querySelector(`#${id}`);

			if ((!this.carouselComponent || !this.carouselComponent.flickity)) {
				setTimeout(() => {
					this.init(retry + 1);
				}, 350);
				return;
			}

			this.flickity = this.carouselComponent.flickity;
			this.buttonPrev = this.querySelector('.js-prev');
			this.buttonNext = this.querySelector('.js-next');

			this.buttonPrev.addEventListener('click', (event) => {
				event.preventDefault();
				this.flickity.previous();
			});

			this.buttonNext.addEventListener('click', (event) => {
				event.preventDefault();
				this.flickity.next();
			});

			this.flickity.on('select', () => {
				this.enableButton(this.buttonPrev);
				this.enableButton(this.buttonNext);

				if (!this.flickity.slides[this.flickity.selectedIndex - 1]) {
					this.disableButton(this.buttonPrev);
				} else if (!this.flickity.slides[this.flickity.selectedIndex + 1]) {
					this.disableButton(this.buttonNext);
				}
			});
		}

		enableButton(button) {
			button.classList.remove('pill-nav-item-disabled');
			button.classList.remove('focus-none');
			button.setAttribute('aria-disabled', 'false');
		}

		disableButton(button) {
			button.classList.add('pill-nav-item-disabled');
			button.classList.add('focus-none');
			button.setAttribute('aria-disabled', 'true');
		}
	});
}
